<template>
  <button v-bind="$attrs" type="button" :class="[
        'common-button-'+ type,
        'common-button-'+ size,
        'common-button-'+ image
    ]" class="common-button" @click="handleClick">
    <!--强制文本不换行-->
    <span v-if="$slots.default" style="white-space: nowrap"><slot></slot></span>
  </button>
</template>

<script>
export default {
  name: "CommonButton",
  props: {
    //可选值: primary cancel text warn
    type: {
      type: String,
      default: 'primary'
    },

    //可选值: big default small mini
    size: {
      type: String,
      default: 'default'
    },

    //可选值: true false
    image: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    handleClick(ev) {
      //触发原有的绑定的click事件
      this.$emit("click", ev)
    }
  }
}
</script>

<style scoped>

button {
  border-radius: 5px;
  font-size: 16px;
}


.common-button-cancel {
  border: #34c5e7 1px solid;
  border-radius: 5px;
  background-color: #ffffff;
  color: #34c5e7;
}

.common-button-cancel:hover {
  background-color: #e9f1f8;
}

.common-button-cancel:active {
  background-color: #dfecfa;
}

.common-button-text {
  border: none;
  background-color: transparent;
  color: #34c5e7;
}

.common-button-text:hover {
  color: #69d5f5;
}

.common-button-text:active {
  color: #82d8f3;
}

.common-button-primary {
  border: #34c5e7 1px solid;
  border-radius: 5px;
  background-color: #34c5e7;
  color: #ffffff;
}

.common-button-primary:hover {
  background-color: #4eccee;
}

.common-button-primary:active {
  background-color: #67dbf1;
}

.common-button-warn {
  border: #e7bd34 1px solid;
  border-radius: 5px;
  background-color: #e7bd34;
  color: #ffffff;
}

.common-button-warn:hover {
  background-color: #e1b945;
}

.common-button-warn:active {
  background-color: #dab852;
}

.common-button-big {
  padding: 10px 35px;
}

.common-button-default {
  padding: 10px 20px;
}

.common-button-small {
  padding: 5px 10px;
}

.common-button-mini {
  padding: 2px 5px;
}

.common-button-true {
  background-image: url(/static/images/fourbackground.png);
}

</style>



// WEBPACK FOOTER //
// src/components/custom/CommonButton.vue